<app-pwa-install-banner />
<app-offline-banner />
<router-outlet />
